
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import { getWrongQuestionList, getCollectionDetailByIds } from "@/api/index";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import QuestionDetail from "../../components/QuestionDetail.vue"
import NoData from "../../components/NoData.vue"
import Rocket from "../../components/Rocket.vue"
import { getCurrentInstance } from "vue";
import { getUrlParam } from "../../utils/parseUrl";
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage } from '@/utils/nativeFn'

@Options({
  components: { 
    QuestionDetail,
    NoData,
    Rocket
  },
})
export default class CollectionIndex extends Vue {
  $store
  $router
  $route
  questionData: any[] = [] // 题目列表
  questionIds: string[] = []
  lists: any[] = [] 
  totalNum: any = ''
  bottomTxt: string = ''
  loading: boolean = false
  finished: boolean = false
  hasAjaxData: boolean = false
  scrollTop: number = 0
  isShowRocket: boolean = false
  hasDetailAndroidMsg: boolean = false
  date: string = '0'
  dateObj: any = {
    0: '全部',
    3: '近3天',
    7: '近一周',
    30: '近1个月',
    90: '近3个月'
  }
  logParamObj: any = {
    0: 'ALL',
    3: 'within 3 days',
    7: 'within 1 week',
    30: 'within 1 month',
    90: 'within 3 months'
  }
  isLoading: boolean = true
  $xesLog = getCurrentInstance()?.appContext.config.globalProperties.$xesLog
  reportDataMap = {
    'page_name': 'false_notebook',
    'biz_name': 'int_lear'
  }
  queryDone: boolean = false
  mounted() {
    // this.getWrongQuestionList();
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      this.getNativeData();
    window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroid);
    }
    window.addEventListener("scroll", this.listenerScroll, true);
  }
  beforeUnmount() {
    window.removeEventListener("scroll", this.listenerScroll, true);
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听题目切换
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.getWrongQuestionList()
        }
      }
    }, 500)
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.queryDone = true
      // 获取到端上数据之后开始调用接口
      this.getWrongQuestionList()
      this.$xesLog.view('false_notebook_pv', {
        ...this.reportDataMap,
        event_type: 'pv',
        source_location: this.$route.query?.source_location || 'null_source',
        event_name: '错题本页面PV'
      })
    })
  }
  chooseDate(dateIndex) {
    if (this.date === dateIndex) {
      return
    }
    if (dateIndex > 7) {
      document.getElementById('dateBox').scrollLeft = 1000
    } else if (dateIndex < 7) {
      document.getElementById('dateBox').scrollLeft = 0
    }
    this.hasAjaxData = false
    this.questionData = []
    this.questionIds = []
    this.finished = false
    this.date = dateIndex
    this.getWrongQuestionList()
    // 点击埋点
    this.$xesLog.track('false_notebook_click', {
      ...this.reportDataMap,
      event_type: 'click',
      selection: this.logParamObj?.[dateIndex] || '',
      event_name: '错题本-页面功能点击'
    })
  }
  // 返回顶部
  goTop() {
    var timer = setInterval(function () {
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      this.isTop = true;
      if (osTop === 0) {
        clearInterval(timer);
      }
    }, 30);
    // 点击埋点
    this.$xesLog.track('false_notebook_click', {
      ...this.reportDataMap,
      event_type: 'click',
      back_top: 'back_top',
      event_name: '错题本-页面功能点击'
    })
  }
  // 安卓监听消息
  receiveAndroid(res) {
    console.log('收到传递过来的安卓消息=====> ', typeof res)
    if (this.hasDetailAndroidMsg) {
      return
    }
    this.hasDetailAndroidMsg = true
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') {
      this.detailNativeData(androidResult.dataJson)
    }
  }
  // 从端上获取数据
  getNativeData() {
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        console.log(res, '11111')
        this.detailNativeData(res)
      }
    })
  }
  // 处理端上数据
  detailNativeData(res) {
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    this.getWrongQuestionList();
    // pv
    this.$xesLog.view('false_notebook_pv', {
      ...this.reportDataMap,
      event_type: 'pv',
      source_location: this.$route.query?.source_location || 'null_source',
      event_name: '错题本页面PV'
    })
  }

  // 监听滚动
  listenerScroll() {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    let clientHeight = document.documentElement.clientHeight;
    let scrollHeight = document.documentElement.scrollHeight;
    let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 4
    if (scrollTop != 0 && bottomOfWindow && !this.loading && !this.finished) {
      this.getCollectionDetailByIds()
    }
    this.scrollTop = scrollTop;
    if (scrollTop > clientHeight) {
      this.isShowRocket = true;
    } else {
      this.isShowRocket = false;
    }
  }
  // 跳转详情页
  linkDetails(question) {
    localStorage.setItem('current_id', question.nry_question_id)
    this.$xesLog.track('false_notebook_click', {
      ...this.reportDataMap,
      event_type: 'click',
      exercise_click: 'exercise_click',
      event_name: '错题本-页面功能点击'
    })
    this.$router.push({
      name: 'WrongQuestionDetail',
    })
  }
  // 获取收藏的题目ids列表
  async getWrongQuestionList() {
    let params = {
      date: this.date
    }
    this.isLoading = true
    await getWrongQuestionList(params).then((res) => {
      this.isLoading = false
      if (res.data.code !== 0) {
        this.hasAjaxData = true
        this.$dialog.alert({
          message: res.data.message,
          confirmButtonText: '我知道了'
        })
        return
      }
      this.lists = res.data.data.list
      this.totalNum = res.data.data.total
      if (!this.lists || this.lists.length === 0) {
        this.hasAjaxData = true
        return
      }
      let temp = []
      this.lists.forEach(item => {
        this.questionIds.push((item as any).nry_question_id);
        temp.push((item as any).nry_question_id);
      })
      this.$store.commit('SET_QUESTION_IDS', temp);
    })
    this.getCollectionDetailByIds()
  }
  // 根据题目ids获取题目详情列表
  getCollectionDetailByIds() {
    if (this.loading) {
      return
    }
    if (this.questionIds.length > 0) {
      let nry_question_ids = this.questionIds.splice(0, 10)
      let data = {
        nry_question_ids,
        action_source: 'wrong_question'
      }
      this.loading = true
      getCollectionDetailByIds(data).then((res) => {
        this.loading = false
        if (res.data.code !== 0) {
          this.questionIds = nry_question_ids.concat(this.questionIds)
          this.hasAjaxData = true
          this.$dialog.alert({
            message: res.data.message,
            confirmButtonText: '我知道了'
          })
          return
        }
        this.questionData = this.questionData.concat(res.data.data.list)
        this.$store.commit('SET_QUESTION_DATA', this.questionData)

        this.hasAjaxData = true
        if (nry_question_ids.length < 10) {
          this.finished = true
        }
      }).catch((err) => {
        this.hasAjaxData = true
        this.loading = false
        console.log('加载列表详情失败：', err)
        this.questionIds = nry_question_ids.concat(this.questionIds)
      })
    }
  }
}
